import bom from '../bom';
import canvas from '../canvas';
import { createSelector } from 'reselect';
import { getImprintedTextDataDict } from '../text/selectors';
import imprintarea from '../imprintarea';
import { selectors as mainSelectors } from '../main';
import template from '../template';

export const canSaveProject = createSelector(
  bom.selectors.getBomOptionsValidation,
  imprintarea.selectors.getSelectedImprintAreaKeys,
  mainSelectors.getIsImprintRequired,
  mainSelectors.getAllowSaveProject,
  template.selectors.getFinalTemplateSelection,
  getImprintedTextDataDict,
  canvas.selectors.getCanvasImageDataDict,
  (
    bomOptionsValidation,
    selectedImprintAreaKeys,
    isImprintRequired,
    allowSaveProject,
    selectedTemplate,
    textDict,
    imageDict
  ) => {
    let canSaveProject = false;
    if (allowSaveProject) {
      if (bomOptionsValidation.isValid) {
        if (selectedImprintAreaKeys.length > 0) {
          if (isImprintRequired) {
            for (let imprintAreaKey of selectedImprintAreaKeys) {
              let hasTemplate = selectedTemplate.templateType !== template.TemplateType.BLANK;
              let textDataList = textDict[imprintAreaKey];
              let hasImprintText = textDataList !== undefined && textDataList.length > 0;
              let imageDataList = imageDict[imprintAreaKey];
              let hasImage = imageDataList !== undefined && imageDataList.length > 0;
              let hasImprint = hasTemplate || hasImprintText || hasImage;
              if (hasImprint) {
                canSaveProject = true;
                break;
              }
            }
          } else {
            canSaveProject = true;
          }
        }
      }
    }
    return canSaveProject;
  }
);

export const getProjectData = createSelector(
  imprintarea.selectors.getImprintFormatDetail,
  template.selectors.getFinalTemplateSelection,
  bom.selectors.getFinalBomOptionsSelection,
  imprintarea.selectors.getSelectedImprintAreaKeys,
  getImprintedTextDataDict,
  canvas.selectors.getCanvasImageDataDict,
  (
    imprintFormatDetail,
    selectedTemplate,
    bomOptionsSelection,
    selectedImprintAreaKeys,
    textDict,
    imageDict
  ) => {
    const projectData = {
      imprintFormatDetail,
      selectedTemplate,
      bomOptionsSelection,
      selectedImprintAreaKeys,
      textDict,
      imageDict
    };
    return projectData;
  }
);
